import { useTheme, useMediaQuery } from '@mui/material';

/**
 * 画面サイズがiPad Miniを縦にした時の横幅以下であればtrueを返す
 *
 * @return {boolean}
 */
export const isVerticalIpadMini = () => {
  const { breakpoints } = useTheme();
  return useMediaQuery(breakpoints.down('md'));
};

/**
 * 画面サイズがiPad Miniを横にした時の横幅以下であればtrueを返す
 *
 * @return {boolean}
 */
export const isHorizontalIpadMini = () => {
  const { breakpoints } = useTheme();
  return useMediaQuery(breakpoints.between(1000, 1030));
};
